import React, { useEffect, useState } from "react";
import axios from "axios";
import * as ReactBootstrap from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import Editbtn from "../Skills/images/circum_edit.svg";
import { Pagination } from "react-bootstrap";
import deletebtn from "../Skills/images/material-symbols-light_delete-outline.svg";
import stepbtn from "../Skills/images/step_btn.svg";
import { useLocation } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { Toast, ToastContainer } from "react-bootstrap";
import { baseURL } from "../../config";

const MasterDesignationTable = () => {
  const [posts, setPosts] = useState({ designation: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  const [editedcategories, setEditedCategories] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const [tablename, setTablename] = useState(null);
  const [showToast, setShowToast] = useState(false);

  const location = useLocation();
  let path = location.pathname;

  const [showAddModal, setShowAddModal] = useState(false);
  const [newEntry, setNewEntry] = useState({});

  const handleShowAddModal = () => setShowAddModal(true);
  const handleCloseAddModal = () => setShowAddModal(false);

  const handleSaveNewEntry = async () => {
    // Add your save logic here
    console.log("New entry saved:", newEntry);
    try {
      if (path === "/adddesignation") {
        const response = await axios.post(
          `${baseURL}/adddesignation`,
          newEntry
        );
        console.log("added Training:", response.data);

        setShowEditModal(false);
      } else if (path === "/adddepartment") {
        const response = await axios.post(
          `${baseURL}/adddepartment`,
          newEntry
        );
        console.log("Updated Training:", response.data);

        setShowEditModal(false);
      }
      window.location.href = path;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.error("Training not found. Please try again.");
      } else {
        console.error("Error updating Training:", error);
      }
    }

    handleCloseAddModal();
  };

  useEffect(() => {
    const fetchPostList = async () => {
      try {
        if (path === "/adddepartment") {
          setTablename("Department");
          const { data } = await axios(`${baseURL}/getdepartments`);
          console.log("Fetched data:", data);
          if (Array.isArray(data.departments)) {
            setPosts({ designation: data.departments });
          } else {
            console.error("Data is not an array:", data);
          }
        } else if (path === "/adddesignation") {
          setTablename("Designation");
          const { data } = await axios(`${baseURL}/getdesignation`);
          console.log("Fetched data:", data);
          if (Array.isArray(data.designation)) {
            setPosts({ designation: data.designation });
          } else {
            console.error("Data is not an array:", data);
          }
        }
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
    fetchPostList();
  }, []);

  const handleDelete = async (categoryId) => {
    try {
      setCategoryToDelete(categoryId);
      setShowDeleteModal(true);
    } catch (error) {
      console.error("Error deleting category:", error);
    }
  };

  const handleSaveEdited = async () => {
    try {
      if (path === "/adddesignation") {
        const response = await axios.post(
          `${baseURL}/updatedesignation?id=${editedcategories.id}`,
          editedcategories
        );
        console.log("Updated Training:", response.data);
        const updatedCategories = posts.designation.map((cats) => {
          if (cats.id === editedcategories.id) {
            return editedcategories;
          }
          return cats;
        });
        setPosts({ designation: updatedCategories });
        setShowEditModal(false);
        setShowToast(true);
      } else if (path === "/adddepartment") {
        const response = await axios.post(
          `${baseURL}/updatedepartment?id=${editedcategories.id}`,
          editedcategories
        );
        console.log("Updated Training:", response.data);
        const updatedCategories = posts.designation.map((cats) => {
          if (cats.id === editedcategories.id) {
            return editedcategories;
          }
          return cats;
        });
        setPosts({ designation: updatedCategories });
        setShowEditModal(false);
        setShowToast(true);
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.error("Training not found. Please try again.");
      } else {
        console.error("Error updating Training:", error);
      }
    }
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  // Get current posts
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.designation.slice(
    indexOfFirstPost,
    indexOfLastPost
  );

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Define handleCloseEditModal, handleCloseCommentModal, handleCloseViewModal functions
  const handleCloseEditModal = () => {
    setShowEditModal(false);
  };

  // Define handleEdit, handleComment, handleView functions
  const handleEdit = (categories) => {
    setEditedCategories(categories);
    setShowEditModal(true);
  };

  const onRowClick = (tempid) => {
    window.location = "/subcategorymain?id=" + tempid;
  };

  const showCategory = () => {};

  return (
    <div>
      <div className="col-lg-12 d-flex mt-2 pb-3">
        <div className="col-lg-6">
          <h4 className="text-start">Master {tablename}</h4>
        </div>
        <div className="col-lg-6 text-end bg-white ">
          <a href="#" className="text-decoration-none text-white">
            <button
              type="button"
              class="btn btn-danger rounded-pill"
              onClick={handleShowAddModal}
            >
              Add {tablename} +
            </button>
          </a>
        </div>
      </div>
      <ReactBootstrap.Table striped bordered hover size="sm">
        <thead className="text-center">
          <tr>
            <th>#</th>
            <th>{tablename}</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentPosts.map((cats, index) => (
            <tr key={index}>
              {Object.values(cats).map((value, idx) => (
                <td key={idx}>{value}</td>
              ))}
              <td className="text-center">
                {/* <ReactBootstrap.Button  onClick={() => onRowClick(categories.id)}  className='bg-transparent border-0'><img src={stepbtn}></img></ReactBootstrap.Button> */}

                <ReactBootstrap.Button
                  className="bg-transparent border-0"
                  onClick={() => handleEdit(cats)}
                >
                  <img src={Editbtn}></img>
                </ReactBootstrap.Button>

                {/* <ReactBootstrap.Button onClick={() => handleComment(skill)}>Comment</ReactBootstrap.Button> */}
                {/* <ReactBootstrap.Button className='bg-transparent border-0' variant="danger" onClick={() => handleDelete(categories.id)}>
                                <img src={deletebtn}></img>
                            </ReactBootstrap.Button> */}
              </td>
            </tr>
          ))}
        </tbody>
      </ReactBootstrap.Table>

      {/* Edit Modal */}
      {showEditModal && editedcategories && (
        <ReactBootstrap.Modal
          show={showEditModal}
          onHide={handleCloseEditModal}
        >
          <ReactBootstrap.Modal.Header closeButton>
            <ReactBootstrap.Modal.Title>
              Edit {tablename}{" "}
            </ReactBootstrap.Modal.Title>
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body>
            {/* Editable form fields */}
            <div>
              <label>{tablename} Name :</label>
              {tablename === "Designation" ? (
                <input
                  className="ml-2 border-0"
                  type="text"
                  value={editedcategories.designation}
                  onChange={(e) =>
                    setEditedCategories({
                      ...editedcategories,
                      designation: e.target.value,
                    })
                  }
                />
              ) : (
                <input
                  className="ml-2 border-0"
                  type="text"
                  value={editedcategories.departmentname}
                  onChange={(e) =>
                    setEditedCategories({
                      ...editedcategories,
                      departmentname: e.target.value,
                    })
                  }
                />
              )}
            </div>

            {/* Add input fields for other attributes as needed */}
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer>
            <ReactBootstrap.Button
              variant="secondary"
              onClick={handleCloseEditModal}
            >
              Close
            </ReactBootstrap.Button>
            {/* On clicking the Update button, call handleSaveEditedSmartGoal to save changes */}
            <ReactBootstrap.Button variant="primary" onClick={handleSaveEdited}>
              Update
            </ReactBootstrap.Button>
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal>
      )}
      {showAddModal && (
        <Modal show={showAddModal} onHide={handleCloseAddModal}>
          <Modal.Header closeButton>
            <Modal.Title>Add New {tablename}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <label>{tablename} Name :</label>
              {tablename === "Designation" ? (
                <input
                  className="ml-2 border-0"
                  type="text"
                  value={newEntry.designation || ""}
                  onChange={(e) =>
                    setNewEntry({ ...newEntry, designation: e.target.value })
                  }
                />
              ) : (
                <input
                  className="ml-2 border-0"
                  type="text"
                  value={newEntry.departmentname || ""}
                  onChange={(e) =>
                    setNewEntry({ ...newEntry, departmentname: e.target.value })
                  }
                />
              )}
            </div>
            {/* Add input fields for other attributes as needed */}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseAddModal}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSaveNewEntry}>
              Add
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      <div>
        {/* Your existing component code */}

        <ToastContainer position="top-end" className="p-3">
          <Toast
            onClose={() => setShowToast(false)}
            show={showToast}
            delay={3000}
            autohide
            className="bg-success text-white"
          >
            <Toast.Header>
              <span className="me-2">✔️</span> {/* Unicode tick mark */}
              <strong className="me-auto">Notification</strong>
            </Toast.Header>
            <Toast.Body>Success!, data updated successfully!</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>

      {/* Pagination */}
      <ReactBootstrap.Pagination>
        {Array.from(
          { length: Math.ceil(posts.designation.length / postsPerPage) },
          (_, index) => (
            <ReactBootstrap.Pagination.Item
              key={index}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </ReactBootstrap.Pagination.Item>
          )
        )}
      </ReactBootstrap.Pagination>
    </div>
  );
};

export default MasterDesignationTable;
